const DEFAULT_URL_PATH = '/BSC/0x16b9a82891338f9bA80E2D6970FddA79D1eb0daE';
const DEFAULT_OVERVIEW_WALLET = '0xf977814e90da44bfa03b6295a0616a897441acec';
const KTN_TOKEN_ADDRESS = '0x491E136FF7FF03E6aB097E54734697Bb5802FC1C';
const AVATAR_PLACEHOLDER =
  'https://kattana-icons.s3.amazonaws.com/avatars/1.png';

const COMPETITION_ENABLED = process.env.REACT_APP_COMPETITION === 'true';
const WELCOME_MODAL_ENABLED = process.env.REACT_APP_WELCOME_MODAL === 'true';
const NATIVE_LIMITS_ENABLED = process.env.REACT_APP_NATIVE_LIMITS === 'true';

export {
  DEFAULT_URL_PATH,
  DEFAULT_OVERVIEW_WALLET,
  KTN_TOKEN_ADDRESS,
  AVATAR_PLACEHOLDER,
  COMPETITION_ENABLED,
  WELCOME_MODAL_ENABLED,
  NATIVE_LIMITS_ENABLED,
};
